import { Component, Input, OnInit } from '@angular/core';
import { LangProductMapper } from '../../../utils/lang-mappers';

@Component({
    selector: 'app-course-card',
    templateUrl: './course-card.component.html',
    styleUrls: ['./course-card.component.scss'],
    standalone: false
})
export class CourseCardComponent implements OnInit {
  @Input() langCode: string;
  @Input() isSupported: boolean;

  constructor() {}

  ngOnInit(): void {}

  getCourseName() {
    return LangProductMapper.mapLangCodeToLangName(this.langCode);
  }

  getCourseClass() {
    if (this.langCode === 'en.bs') return 'course-enbus';
    if (this.langCode === 'en.ch') return 'course-encfk';
    return `course-${this.langCode}`;
  }
}
